import React from 'react';
import { Link } from 'react-router-dom';
import { currentQueryParams, pathForQueryParams } from './helpers';
import FilterOptionList from './optionList';
import FilterOptionListItem from './optionListItem';
import FilterOptionListMoreToggle from './optionListMoreToggle';
import { listItemLabel } from './styles.mod.scss';
import { Body, SecondarySmall } from 'scy/text';

const TRUNC_LENGTH = 4;

function areActiveQueryParams(queryParams, currentParams) {
  return Object.keys(queryParams).reduce((res, key) => {
    return res && (key === 'skip' || queryParams[key] == currentParams[key]);
  }, true);
}

export default class FilterItemOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = { more: false };
  }

  render() {
    const { options, location, onSelect } = this.props;
    const currentParams = currentQueryParams(location);
    const displayedOptions = this.state.more
      ? options
      : options.slice(0, TRUNC_LENGTH);

    return (
      <FilterOptionList>
        {displayedOptions.map(({ label, count, facet, queryParams }) => {
          const isActive = areActiveQueryParams(queryParams, currentParams);
          const path =
            isActive && !!facet
              ? pathForQueryParams(location, { skip: null, [facet]: null })
              : pathForQueryParams(location, { skip: null, ...queryParams });

          return (
            <Link to={path} replace={!currentParams.skip} key={label}>
              <FilterOptionListItem
                isActive={isActive}
                onClick={isActive ? null : onSelect}
              >
                <Body tag="span" className={listItemLabel}>
                  {label}
                </Body>
                <SecondarySmall tag="span">
                  {!!count && ` (${count})`}
                </SecondarySmall>
              </FilterOptionListItem>
            </Link>
          );
        })}

        {options.length > TRUNC_LENGTH && (
          <FilterOptionListMoreToggle
            expanded={this.state.more}
            showMore={() => this.setState({ more: true })}
            showLess={() => this.setState({ more: false })}
          />
        )}
      </FilterOptionList>
    );
  }
}
